import { render, staticRenderFns } from "./OpeningHours.vue?vue&type=template&id=5352720d&scoped=true"
import script from "./OpeningHours.vue?vue&type=script&lang=js"
export * from "./OpeningHours.vue?vue&type=script&lang=js"
import style0 from "./OpeningHours.vue?vue&type=style&index=0&id=5352720d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352720d",
  null
  
)

export default component.exports